const SvgDatabases2 = (props) => (
  <>
    <path
      d="M0 0v32h192V0H0Zm18 24h-4V8h4v16Zm16 0h-4V8h4v16Zm16 0h-4V8h4v16Zm16 0h-4V8h4v16ZM0 48v32h192V48H0Zm18 24h-4V56h4v16Zm16 0h-4V56h4v16Zm16 0h-4V56h4v16Zm16 0h-4V56h4v16ZM0 96v32h192V96H0Zm18 24h-4v-16h4v16Zm16 0h-4v-16h4v16Zm16 0h-4v-16h4v16Zm16 0h-4v-16h4v16ZM0 144v32h192v-32H0Zm18 24h-4v-16h4v16Zm16 0h-4v-16h4v16Zm16 0h-4v-16h4v16Zm16 0h-4v-16h4v16Z"
      fill={props.p20}
    />
  </>
);

export default SvgDatabases2;
